import Cookies from 'js-cookie'

export default () => {

    // Element
    const supportBlock = $('#js-support-block')
    let supportBlockWasShown = Cookies.get('support-block-shown')

    if(supportBlockWasShown === undefined) {
        setTimeout(() => {
            Cookies.set('support-block-shown', true)
            supportBlock.addClass('support-block--active')
        }, 10000)
    }

    // Bind close button
    supportBlock.find('[data-close]').on('click', event => {
        event.preventDefault()
        supportBlock.removeClass('support-block--active')
    })

    supportBlock.find('.js-telephone-number').on('click', event => {
        if(!supportBlock.hasClass('support-block--active')) {
            event.preventDefault()
            supportBlock.addClass('support-block--active')
        }
    })

};
